
import React from "react";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";

interface StaticTextHeaderProps {
  loadStaticContent: () => Promise<void>;
}

const StaticTextHeader: React.FC<StaticTextHeaderProps> = ({ loadStaticContent }) => {
  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between mb-6">
      <div>
        <h1 className="text-2xl font-bold">Textos Fixos</h1>
        <p className="text-gray-500">Gerenciamento dos textos fixos do site</p>
      </div>
      <div className="mt-4 md:mt-0 flex gap-4">
        <Button 
          variant="outline"
          onClick={loadStaticContent}
        >
          <RefreshCw className="w-4 h-4 mr-2" />
          Atualizar
        </Button>
      </div>
    </div>
  );
};

export default StaticTextHeader;
